import { render, staticRenderFns } from "./cancelOrReject.vue?vue&type=template&id=98b3b21a&scoped=true"
import script from "./cancelOrReject.vue?vue&type=script&lang=js"
export * from "./cancelOrReject.vue?vue&type=script&lang=js"
import style0 from "./cancelOrReject.vue?vue&type=style&index=0&id=98b3b21a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b3b21a",
  null
  
)

export default component.exports